/* eslint-disable */

// Lib imports
import axios from 'axios'
import store from '@/store'
import authService from '@/auth/AuthService'

var instance = axios.create({
    baseURL: AppConfig.spillsapiurl
    // baseURL: process.env.VUE_APP_SPILLSAPIURL
})

instance.interceptors.request.use(async function (config) {
    store.commit('app/setHttpRunning', true)

    //check that the token is unexpired before any request
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    const currentTime = new Date().getTime()

    if (expiresAt != null && currentTime >= expiresAt) {
        try {
            console.log("Token expired, renewing token")
            await authService.renewTokens()
        } catch (err) {
            console.log("Redirecting to login, failed to renew token:", err)
            authService.login()
        }
    }

    const token = localStorage.getItem('id_token')
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
}, function (error) {
    return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
        store.commit('app/setHttpRunning', false)
        return response
    }, 
    async function (error) {
        store.commit('app/setHttpRunning', false)
        var errorObject = {
            url: error.config.url.replace(error.config.baseURL, ''),
            status: error.response ? error.response.status + ' - ' : '',
            message: error.message,
            stack: error.stack
        }
        store.commit('app/addError', errorObject)
        return Promise.reject(error)
    }
)

export default instance
